import React from 'react';
import { useParams } from 'react-router-dom';
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import EventPageLoader from './EventPageLoader';
import { EventContextProvider, EventType } from 'providers/EventProvider';
import Event from './Event';

const gqlQuery = gql`
  query GetSubEvent($slug: String!, $sub: String) {
    liveEvent: getLiveEvent(slug: $slug, sub: $sub) {
      id
      isLive
      slug
      sub
      name
      startDate
      endDate
      publicDate
      isOpen
      analytic
      delay
      markerType
      location {
        lat
        lng
      }
      zoom
      status
      logos {
        id
        url
        name
        position
        width
      }
      competitors {
        id
        color
        name
        deviceName
        shortName
        startTime
        isVirtual
      }
      maps {
        id
        name
        topLeft {
          lat
          lng
        }
        topRight {
          lat
          lng
        }
        bottomLeft {
          lat
          lng
        }
        height
        width
        url
        show
      }
      routes {
        id
        name
        color
        track {
          lat
          lng
        }
      }
      controls {
        id
        name
        type
        position {
          lat
          lng
        }
      }
      subEvents {
        name
        sub
      }
    }
  }
`;

const EventPage = () => {
  const { slug, sub } = useParams();

  const { error, loading, data } = useQuery<{ liveEvent: EventType }>(gqlQuery, {
    variables: {
      slug,
      sub
    },
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first'
  });

  React.useEffect(() => {
    if (data?.liveEvent?.name) {
      document.title = `LiveZone - ${data.liveEvent.name}`;
    }
  }, [data?.liveEvent?.name]);

  if (loading) return <EventPageLoader />;

  if (error || !data?.liveEvent) {
    return <>Something wrong</>;
  }

  return (
    <EventContextProvider
      value={{
        event: data.liveEvent,
        options: {
          showAllPlayers: true,
          isMassStart: false,
          isStop: !data.liveEvent.isLive,
          isLive: data.liveEvent.isLive,
          startEventTime: new Date(data.liveEvent.startDate).getTime(),
          tail: 60,
          routeOpacity: 0.8,
          routeWeight: 3,
          speed: 1,
          center: data.liveEvent.location,
          hiddenRouteIds: [],
          liveSync: 0
        }
      }}
    >
      <Event />
    </EventContextProvider>
  );
};
export default EventPage;
